
// Vue
import {Options, Vue} from "vue-class-component";

// Models
import {AppAdministratorDiagnosticsRootListFormUpdate} from "@/models/app/administrator/diagnostics/root/list/form/update";
import {ResponseIndex} from "@/models/response";

// Components
import {
  ElDialog,
  ElForm,
  ElFormItem,
  ElInput,
  ElInputNumber,
  ElSelect,
  ElOption,
  ElDatePicker,
  ElTimeSelect,
  ElButton,
} from "element-plus";
import {Edit} from "@element-plus/icons-vue";

// Services
import {postRequest} from "@/services/api/request";

@Options({
  props: [
    "diagnostic",
  ],
  components: {
    ElDialog,
    ElForm,
    ElFormItem,
    ElInput,
    ElInputNumber,
    ElSelect,
    ElOption,
    ElDatePicker,
    ElTimeSelect,
    ElButton,
    Edit,
  },
})
export default class AppAdministratorDiagnosticsRootListFormUpdateIndexVue extends Vue {
  isLoading: boolean | null = false;
  isDialogVisible: boolean | null = false;

  diagnostic: AppAdministratorDiagnosticsRootListFormUpdate = new AppAdministratorDiagnosticsRootListFormUpdate();

  formData: AppAdministratorDiagnosticsRootListFormUpdate = new AppAdministratorDiagnosticsRootListFormUpdate();
  formDataRules = {
    content: {
      date: [
        {
          required: true,
          message: "Polje nije popunjeno",
          trigger: "blur",
        },
      ],
    },
  };

  $refs!: {
    formComponent: HTMLFormElement;
  };

  validateForm(): void {
    this.$refs.formComponent.validate((response: any) => {
      if (response) {
        this.submitForm();
      }
    });
  }

  async submitForm(): Promise<void> {
    this.isLoading = true;
    await postRequest({
      uri: "/common/diagnostic/update",
      formData: this.formData,
      isProtected: true,
      isSuccessNotificationVisible: true,
      isErrorNotificationVisible: true,
    }).then((r: ResponseIndex) => {
      if (r.status === "success") {
        this.$emit('getDiagnostics');
        this.isDialogVisible = false;
        this.resetFormData();
      }
    });
    this.isLoading = false;
  }

  setFormData(): void {
    const fields = [];

    this.diagnostic.diagnostic_category.content.fields.forEach((fieldDiagnosticCategory: any) => {
      fields.push({
        value: null,
        name: fieldDiagnosticCategory.name,
        property: fieldDiagnosticCategory.property,
      });
    });

    fields.forEach((field: any) => {
      const fieldDiagnostic = this.diagnostic.content.fields.filter((item: any) => {
        return item.property === field.property;
      });

      if (fieldDiagnostic.length === 0) {
        this.diagnostic.content.fields.push({
          value: null,
          name: field.name,
          property: field.property,
        });
      }
    });

    this.formData = this.diagnostic;
  }

  resetFormData(): void {
    this.formData = new AppAdministratorDiagnosticsRootListFormUpdate();
  }

  updated(): void {
    this.setFormData();
  }
}
